export const ICON_LIST = [
  { icon: "fas fa-file", text: "書類1" },
  { icon: "fas fa-file-code", text: "書類2" },
  { icon: "fas fa-file-invoice-dollar", text: "書類3" },
  { icon: "fas fa-file-word", text: "書類4" },
  { icon: "fas fa-file-excel", text: "書類5" },
  { icon: "fas fa-file-powerpoint", text: "書類6" },
  { icon: "fas fa-folder", text: "フォルダ" },
  { icon: "fas fa-desktop", text: "モニター" },
  { icon: "fas fa-tag", text: "タグ" },
  { icon: "fas fa-stopwatch", text: "ストップウォッチ" },
  { icon: "fas fa-star", text: "スター" },
  { icon: "fas fa-wrench", text: "レンチ" },
  { icon: "fas fa-robot", text: "ロボット" },
  { icon: "fas fa-pen", text: "ペン1" },
  { icon: "fas fa-pen-fancy", text: "ペン2" },
  { icon: "fas fa-music", text: "音楽" },
  { icon: "fas fa-map", text: "地図" },
  { icon: "fas fa-lightbulb", text: "電球" },
  { icon: "fas fa-image", text: "絵" },
  { icon: "fas fa-heart", text: "ハート" },
  { icon: "fas fa-headset", text: "ヘッドセット" },
  { icon: "fas fa-hammer", text: "ハンマー" },
  { icon: "fas fa-globe", text: "地球" },
  { icon: "fas fa-gamepad", text: "コントローラー" },
  { icon: "fas fa-flask", text: "フラスコ" },
  { icon: "fas fa-flag", text: "旗" },
  { icon: "fas fa-envelope", text: "メール" },
  { icon: "fas fa-database", text: "データベース" },
  { icon: "fas fa-cubes", text: "キューブ" },
  { icon: "fas fa-crown", text: "王冠" },
  { icon: "fas fa-comment-dots", text: "コメント" },
  { icon: "fas fa-clock", text: "時計" },
  { icon: "fas fa-circle", text: "円" },
  { icon: "fas fa-camera", text: "カメラ" },
  { icon: "fas fa-book", text: "本" },
  { icon: "fas fa-bell", text: "ベル" },
  { icon: "fas fa-video", text: "ビデオ" },
  { icon: "fas fa-cog", text: "歯車" },
]

export default ICON_LIST
